import './App.css';
import About from './Components/About';
import Contact from './Components/Contact';
import Experiences from './Components/Clients';
import Expertise from './Components/Expertise';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Portfolio from './Components/Portfolio'
import { Parallax } from 'react-parallax'

function App() {
  const imageHome = './img/iStock-920835832_comp2.jpg'
  const imageAbout = './img/tianyi-ma-WiONHd_zYI4-unsplash.jpg'
  const imageExpertise = './img/markus-spiske-hvSr_CVecVI-unsplash.jpg'
  const imageExperiences = './img/kevin-ku-w7ZyuGYNpRQ-unsplash.jpg'
  const imagePortfolio = './img/tomasz-frankowski-kBUfvkbFIoE-unsplash.jpg'
  const imageContact = './img/michael-descharles-NMkECjnU0IY-unsplash.jpg'

  return (
    <div className="page-container">
      <Parallax
        blur={{ min: -15, max: 15 }}
        bgImage={imageHome}
        strength={500}
        lazy={true}
      >
        <Home />
      </Parallax>
      <Parallax
        blur={{ min: -15, max: 15 }}
        bgImage={imageAbout}
        strength={500}
        lazy={true}
      >
        <About />
      </Parallax>
      <Parallax
        blur={{ min: -15, max: 15 }}
        bgImage={imageExpertise}
        strength={500}
        lazy={true}
      >
        <Expertise />
      </Parallax>
      <Parallax bgImage={imageExperiences} strength={500} lazy={true}>
        <Experiences />
      </Parallax>
      <Parallax
        blur={{ min: -15, max: 15 }}
        bgImage={imagePortfolio}
        strength={500}
        lazy={true}
      >
        <Portfolio />
      </Parallax>
      <Parallax
        blur={{ min: 15, max: -15 }}
        bgImage={imageContact}
        strength={500}
        lazy={true}
      >
        <Contact />
      </Parallax>
      <Footer />
    </div>
  )
}

export default App;
